import { forwardRef } from "react";
import DatePicker, { ReactDatePicker } from "react-datepicker";
import { PropsWithClassName } from "../../../models/props-with-class-name";
import styles from "./YearInput.module.css";
import useResponsive from "../../../hooks/useResponsive";

export type YearInputProps = PropsWithClassName<{
  value?: Date;
  min?: Date;
  max?: Date;
  onChange?: (value: string) => void;
  placeholder?: string;
  isInvalid?: boolean;
  disabled?: boolean;
  isClearable?: boolean;
  readOnly?: boolean;
}>;

const YearInput = forwardRef<ReactDatePicker, YearInputProps>(
  (
    {
      value,
      min,
      max,
      placeholder,
      isInvalid,
      onChange,
      className,
      disabled,
      readOnly,
      isClearable = true,
    }: YearInputProps,
    ref
  ) => {
    const changeHandler = (date: Date) => {
      if (onChange) onChange(date?.toISOString());
    };

    const { isMobile } = useResponsive();

    return (
      <div className={`${styles.date} position-relative z-index-max`}>
        <DatePicker
          ref={ref}
          className={`app-form-input form-control form-control-sm  ${
            styles.input
          } ${className} ${isInvalid ? "invalid" : ""}`}
          calendarClassName={styles.calendar}
          isClearable={isClearable}
          showYearPicker
          dateFormat="yyyy"
          openToDate={new Date("1980")}
          showPopperArrow={false}
          selected={value}
          onChange={changeHandler}
          onFocus={isMobile ? (e) => e.target.blur() : undefined}
          placeholderText={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          minDate={min}
          maxDate={max}
          disabledKeyboardNavigation
        />
      </div>
    );
  }
);

export default YearInput;
